import { createApp } from "vue";
import App from "./App.vue";
import "@/assets/iconfont/iconfont.css";
import router from "./router"; //路由
import store from "./store"; //store
import "normalize.css"; //兼容
import "./assets/css/index.less";
import register from "./global"; //element plus && format
import 'default-passive-events'
import print from 'vue3-print-nb'

import { ElLoading } from 'element-plus'//【新增】
const app = createApp(App)

app.directive('loading',ElLoading.directive)//【新增】
app.use(print).use(register).use(store).use(router).mount("#app")
